import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { debounceTime, max } from "rxjs";
import { c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-media-picker-component",
  templateUrl: "./button-media-picker-component.component.html",
  styleUrls: ["./button-media-picker-component.component.scss"],
})
export class ButtonMediaPickerComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService,
  ) {}

  mediaform: UntypedFormGroup; // bootstrap validation form

  @Input() button_id: string;
  @Input() config: any;
  button: MenuButton;
  mode: string;

  // default values
  offCanvasSubscription: any;
  currentMenuSubscription: any;
  colorsComponentSubscription: any;
  valueChangesSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_text: string;
  row_id: string;
  labelColor: string;
  black_color: string = "#000000";
  enableCustomColor: boolean = false;
  enableCustomGradientColor: boolean = false;

  button_label_color: string;
  button_label_style: any;
  button_button_divider: number;

  data: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  modalRef?: BsModalRef;
  icon: any;
  trailing_icon: any;
  iconType: number;
  fontSize = "md";
  density = 0;
  textAlign = "left";
  isAndroid: boolean;
  light: boolean;
  text_id: any;
  colors: any;
  labelDarkColor: any;
  button_color_item: any = { schemes: { light: {}, dark: {} } };
  button_color_light: any = {};
  button_color_dark: any = {};
  sync = true;
  os_name: string;
  fontID: string;
  alginID: string;
  densityID: string;

  startColor: string;
  startDarkColor: string;
  endColor: string;
  endDarkColor: string;
  divider: number;
  colorObject: any;
  selectedColor;
  enableBg: boolean;

  sourcesList = [
    { name: "Camera", key: "camera" },
    { name: "Gallery", key: "gallery" },
  ];

  extensionsList = [
    // Documents
    { name: "PDF", key: "pdf" },
    { name: "DOC", key: "doc" },
    { name: "DOCX", key: "docx" },
    { name: "XLS", key: "xls" },
    { name: "XLSX", key: "xlsx" },
    { name: "PPT", key: "ppt" },
    { name: "PPTX", key: "pptx" },
    { name: "TXT", key: "txt" },
    { name: "CSV", key: "csv" },
    { name: "RTF", key: "rtf" },

    // Images
    { name: "JPG", key: "jpg" },
    { name: "JPEG", key: "jpeg" },
    { name: "PNG", key: "png" },
    { name: "WEBP", key: "webp" },
    { name: "GIF", key: "gif" },
    { name: "HEIC", key: "heic" },
    { name: "HEIF", key: "heif" },

    // Videos
    { name: "MP4", key: "mp4" },
    { name: "MOV", key: "mov" },
    { name: "MKV", key: "mkv" },
    { name: "WEBM", key: "webm" },
    { name: "AVI", key: "avi" },

    // Audio
    { name: "MP3", key: "mp3" },
    { name: "WAV", key: "wav" },
    { name: "M4A", key: "m4a" },
    { name: "AAC", key: "aac" },
    { name: "OGG", key: "ogg" },

    // Archives
    { name: "ZIP", key: "zip" },
    { name: "RAR", key: "rar" },
    { name: "7Z", key: "7z" },
    { name: "TAR", key: "tar" },
    { name: "GZ", key: "gz" },

    // Data
    { name: "JSON", key: "json" },
    { name: "XML", key: "xml" },
    { name: "YAML", key: "yaml" },
    { name: "YML", key: "yml" },
  ];

  enableMultiple = false;
  enableCompression = false;
  enableCrop = false;
  enableBase64 = false;

  ngOnInit() {
    this.field_id = this.config.id;
    this.fontID = this.mdw.makeRef(16);
    this.densityID = this.mdw.makeRef(16);
    this.alginID = this.mdw.makeRef(16);
    this.mediaform = this.formBuilder.group({
      sources: new UntypedFormControl([]),
      allowed_extensions: new UntypedFormControl([]),
      allow_multiple: new UntypedFormControl(0),
      max_files: new UntypedFormControl(1),
      max_size_mb: new UntypedFormControl(20),
      duration_limit_sec: new UntypedFormControl(20),
      aspect_ratio: new UntypedFormControl("1:1"),
      compression_enabled: new UntypedFormControl(0),
      crop_enabled: new UntypedFormControl(0),
      compression: this.formBuilder.group({
        image_quality: new UntypedFormControl(1),
        max_height: new UntypedFormControl(520),
        max_width: new UntypedFormControl(520),
      }),
      base64: new UntypedFormControl(0),
    });
    this.sortedButtonList = [];
    this.buttonList = {};

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      },
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      },
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
          this.light = data.light;
        }
      });
  }

  updatelist(e) {
    let sour = [];
    for (let i = 0; i < e.length; i++) {
      sour.push(e[i].key);
    }
    this.mediaform.patchValue({
      sources: sour,
    });

    this.onFormChange();
  }

  togglePostTags(status) {
    this.enableMultiple = status;
    this.mediaform.patchValue({
      allow_multiple: status ? 1 : 0,
    });
    this.onFormChange();
  }
  togglecompression(status) {
    this.enableCompression = status;
    this.mediaform.patchValue({
      compression_enabled: status ? 1 : 0,
    });
    this.onFormChange();
  }
  togglecrop(status) {
    this.enableCrop = status;
    this.mediaform.patchValue({
      crop_enabled: status ? 1 : 0,
    });
    this.onFormChange();
  }
  toggleBase64(status) {
    this.enableBase64 = status;
    this.mediaform.patchValue({
      base64: status ? 1 : 0,
    });
    this.onFormChange();
  }
  buttonIntialize(data) {
    this.data = data.data;

    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.field_id = this.config.id;
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.os_name = this.sync ? null : this.isAndroid ? "Android" : "iOS";
      let style = this.isAndroid
        ? this.button.button_style
        : this.button.button_style_ios;
      this.enableBg = style.includes("03") ? true : false;
      this.mediaform = this.formBuilder.group({
        sources: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.sources
            ? this.button.button_media_picker.sources
            : [],
        ),
        allowed_extensions: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.allowed_extensions
            ? this.button.button_media_picker.allowed_extensions
            : [],
        ),
        allow_multiple: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.allow_multiple
            ? this.button.button_media_picker.allow_multiple
            : 0,
        ),
        max_files: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.max_files
            ? this.button.button_media_picker.max_files
            : 1,
        ),
        max_size_mb: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.max_size_mb
            ? this.button.button_media_picker.max_size_mb
            : 20,
        ),
        duration_limit_sec: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.duration_limit_sec
            ? this.button.button_media_picker.duration_limit_sec
            : 20,
        ),
        aspect_ratio: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.crop &&
            this.button.button_media_picker.crop.aspect_ratio
            ? this.button.button_media_picker.crop.aspect_ratio
            : "1:1",
        ),
        compression_enabled: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.compression &&
            this.button.button_media_picker.compression.enabled
            ? this.button.button_media_picker.compression.enabled
            : 0,
        ),
        crop_enabled: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.crop &&
            this.button.button_media_picker.crop.enabled
            ? this.button.button_media_picker.crop.enabled
            : 0,
        ),
        compression: this.formBuilder.group({
          image_quality: new UntypedFormControl(
            this.button.button_media_picker &&
              this.button.button_media_picker.compression &&
              this.button.button_media_picker.compression.image_quality
              ? this.button.button_media_picker.compression.image_quality
              : 1,
          ),
          max_height: new UntypedFormControl(
            this.button.button_media_picker &&
              this.button.button_media_picker.compression &&
              this.button.button_media_picker.compression.max_height
              ? this.button.button_media_picker.compression.max_height
              : 520,
          ),
          max_width: new UntypedFormControl(
            this.button.button_media_picker &&
              this.button.button_media_picker.compression &&
              this.button.button_media_picker.compression.max_width
              ? this.button.button_media_picker.compression.max_width
              : 520,
          ),
        }),
        base64: new UntypedFormControl(
          this.button.button_media_picker &&
            this.button.button_media_picker.base64
            ? this.button.button_media_picker.base64
            : 0,
        ),
      });

      if (this.mediaform.get("allow_multiple").value) {
        this.enableMultiple = true;
      } else {
        this.enableMultiple = false;
      }

      if (this.mediaform.get("compression_enabled").value) {
        this.enableCompression = true;
      } else {
        this.enableCompression = false;
      }
      if (this.mediaform.get("crop_enabled").value) {
        this.enableCrop = true;
      } else {
        this.enableCrop = false;
      }
      if (this.mediaform.get("base64").value) {
        this.enableBase64 = true;
      } else {
        this.enableBase64 = false;
      }
    }
  }

  onFormChange() {
    const value = {
      allow_multiple: this.mediaform.value.allow_multiple,
      // max_files: this.mediaform.value.max_files,
      max_size_mb: this.mediaform.value.max_size_mb,
      compression: {
        enabled: this.mediaform.value.compression_enabled,
      },
      crop: {
        enabled: this.mediaform.value.crop_enabled,
      },
      base64: this.mediaform.value.base64,
    };
    if (this.config?.media_type == "file") {
      value["allowed_extensions"] = this.mediaform.value.allowed_extensions;
    }
    if (this.config?.media_type != "file") {
      value["sources"] = this.mediaform.value.sources;
    }
    if (this.config?.media_type == "video") {
      value["duration_limit_sec"] = this.mediaform.value.duration_limit_sec;
    }
    if (this.config?.media_type == "image") {
      value["max_files"] = this.mediaform.value.max_files;
      value["crop"]["aspect_ratio"] = this.mediaform.value.aspect_ratio;

      value["crop"]["height"] =
        this.mediaform.get("compression").value.max_height;
      value["crop"]["width"] =
        this.mediaform.get("compression").value.max_width;
    }
    if (this.config?.media_type == "image") {
      value["compression"]["image_quality"] =
        this.mediaform.value.compression.image_quality;
      value["compression"]["max_height"] =
        this.mediaform.value.compression.max_height;
      value["compression"]["max_width"] =
        this.mediaform.value.compression.max_width;
    }
    this.button.button_media_picker = value;
    this.updateButtonData();
  }

  valueChange(e) {
    const value = e.target.value;
    console.log(value);
    this.mediaform.get("compression").patchValue({
      image_quality: value,
    });
    this.onFormChange();
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id,
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true,
    );
  }

  parseAspect(aspect: string): { w: number; h: number; ratio: number } {
    const [w, h] = aspect.split(":").map(Number);

    if (!w || !h) {
      throw new Error(`Invalid aspect ratio: ${aspect}`);
    }

    return {
      w,
      h,
      ratio: w / h,
    };
  }

  heightFromWidth(width: number, aspect: string): number {
    const { ratio } = this.parseAspect(aspect);
    return Math.round(width / ratio);
  }

  widthFromHeight(height: number, aspect: string): number {
    const { ratio } = this.parseAspect(aspect);
    return Math.round(height * ratio);
  }

  getLockedDimension(aspect: string): "width" | "height" | "none" {
    const { w, h } = this.parseAspect(aspect);

    if (w === h) return "none"; // 1:1
    if (w > h) return "height"; // wide
    return "width"; // tall
  }

  get locked(): "width" | "height" | "none" {
    return this.getLockedDimension(this.mediaform.value.aspect_ratio);
  }

  onWidthChange(): void {
    const maxWidth = this.mediaform.value.compression.max_width;
    console.log(this.locked);
    if (this.locked === "none" || this.locked === "height") {
      const maxHeight = this.heightFromWidth(
        maxWidth,
        this.mediaform.value.aspect_ratio,
      );
      console.log(maxHeight);
      this.mediaform.get("compression").patchValue({
        max_width: maxWidth,
        max_height: maxHeight,
      });
    }

    this.onFormChange();
  }

  onHeightChange(): void {
    let maxHeight = this.mediaform.value.compression.max_height;
    if (this.locked === "none" || this.locked === "width") {
      let maxWidth = this.widthFromHeight(
        maxHeight,
        this.mediaform.value.aspect_ratio,
      );

      this.mediaform.get("compression").patchValue({
        max_width: maxWidth,
        max_height: maxHeight,
      });
    }

    this.onFormChange();
  }

  onAspectChange(): void {
    const aspects = this.mediaform.value.aspect_ratio;
    let maxWidth = this.mediaform.value.compression.max_width;
    let maxHeight = this.mediaform.value.compression.max_height;

    const locked = this.getLockedDimension(aspects);
    if (locked === "width") {
      maxWidth = this.widthFromHeight(maxHeight, aspects);
      this.mediaform.get("compression").patchValue({
        max_width: maxWidth,
      });
    } else {
      maxHeight = this.heightFromWidth(maxWidth, aspects);
      this.mediaform.get("compression").patchValue({
        max_height: maxHeight,
      });
    }
    this.onFormChange();
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }
}
